import LoadingComponent from 'components/Loading';
const Loading = () => (
   <div className='h-[100vh] w-[100vw] bg-[#ffffff] dark:bg-[#2E2D2D]'>
      <LoadingComponent />
   </div>
);
export default Loading;
